import * as React from "react";
import { Columns, Column, Box, Stack, Heading } from "@origin-digital/ods-core";
import { HSNextBestAction } from "./HSNextBestAction";

export interface IOfferContent {
  experienceId: string;
}

export interface IPrimaryPlacement {
  offers: IOfferContent[];
  heading: string;
}

export const PrimaryPlacement = ({ heading, offers }: IPrimaryPlacement) => {
  if (offers.length === 0) {
    return null;
  }

  const displayable = offers.slice(0, 2);

  return (
    <Box marginTop="xxlarge">
      <Stack space="xlarge" data-id="primary-placement">
        <Heading variant="h3">{heading}</Heading>
        <Columns collapseBelow="lg" space="xlarge">
          {displayable.map((displayableContent) => (
            <Column
              width="1/2"
              key={displayableContent.experienceId}
              data-id="primary-placement-column"
            >
              <HSNextBestAction content={displayableContent as any} />
            </Column>
          ))}
        </Columns>
      </Stack>
    </Box>
  );
};
